import { createContext } from "react";

export interface AuthenticationContextType {
    requireAuthenticatedUser: () => void;
}

const initialValue: AuthenticationContextType = {
    requireAuthenticatedUser: () => {},
};

export const AuthenticationContext = createContext(initialValue);
